export const environment = {
  production: false,
  apiUrl: 'https://www.ezhuthupizhai.com/admin/',
  // apiUrl: 'http://localhost/ezhuthupizhai/admin/',
  razorpayKeyId: 'rzp_live_Vz1px4jbCBxnV0'
};